import React, { useState, useRef } from 'react';
import { Link } from 'react-router-dom';

const MobileMenuItems = ({ mobileItems, closeMenu }) => {
  const [clicked, setClicked] = useState(false);
  const contentEl = useRef();

  const handleToggle = () => {
    setClicked((prev) => !prev);
  };

  return (
    <li className={`mobile-item ${clicked ? "active" : ""}`}>
      {mobileItems.submenu ? (
        <div>  
          <button className="mobile-btn" onClick={handleToggle}>
            {mobileItems.label}
            <span className="mobile-dropdown-icon">{clicked ? "-" : "+"}</span>
          </button>
          <ul 
            ref={contentEl} 
            className="submenu_wrapper" 
            style={
              clicked
                ? { height: contentEl.current.scrollHeight }
                : { height: "0px" }
            }
          >
            {mobileItems.submenu.map((submenu) => (
              <li className="submenu-items" onClick={closeMenu}>
                {submenu.path.includes("https") ? (
                <a
                  href={submenu.path}
                  target={submenu.target}
                  rel={submenu.rel}
                >
                  {submenu.label}
                </a>
              ) : (
                <Link to={submenu.path}>
                  {submenu.label}
                </Link>
              )}
              </li>
            ))}
          </ul>
        </div>
      ) : (
        <a 
          href={mobileItems.path}
          target={mobileItems.target}
          rel={mobileItems.rel} 
          onClick={closeMenu}
        >
          <button className="mobile-btn">
            {mobileItems.label}
          </button>
        </a>
      )}
    </li>
  );
};

export default MobileMenuItems;